<template>
  
<div class="p-4 h-screen">

    <div class="d-flex w-full flex-row gap-3" v-if="splitProductCols">
        <!-- First Col -->
        <div class="d-flex flex-column w-full gap-3">
        <product v-for="(product, key) in splitProductCols[0]" :key="key +'-product-col-1'" :product="product"></product>
        </div>
        <!-- Sec Col -->
        <div class="d-flex flex-column w-full gap-3">
            <product v-for="(product, key) in splitProductCols[1]" :key="key +'-product-col-2'" :product="product"></product>
        </div>
        <!-- Third Col -->
        <div class="d-none d-md-flex flex-column w-full gap-3">
            <product v-for="(product, key) in splitProductCols[2]" :key="key +'-product-col-3'" :product="product"></product>
        </div>
        <!-- fourth -->
        <div class="d-none d-md-flex flex-column w-full gap-3">
            <product v-for="(product, key) in splitProductCols[3]" :key="key +'-product-col-3'" :product="product"></product>
        </div>
    </div>
    
    <div v-if="loading && !finished_loading_results" class="text-center">

        <strong>Loading...</strong>
        <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
    </div>
    <div v-else-if="!loading && !products.length ">
        <strong>Your existing filters have produced no results - please try a different combination.</strong>
    </div>
    <div v-if="finished_loading_results" class="text-center">
        <strong>Reached end of results</strong>
    </div>
    
</div>

</template>

<script>
import axios from 'axios'
import product from './product.vue';
export default {
    components: { product },
    name: 'products',
    props: { 
        members_url: String, 
        disableScroll : {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            page: 1,
            lastValidPage: 1,
            products : [],
            loading:  false ,
            finished_loading_results:  false ,
            cols:  4,
            categories: [],
            mediums: [],
            search: '',
            aritst_id: '',
            subjects: [],
            styles: [],
            orientations: [],
            price_range: [],
            colours: [],
            preloadOffset: 50,
            bootstrap_min_width: {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1400,
            },
            width: window.innerWidth
        }
    },

    computed: {
        splitProductCols() 
        {   
            var products = [];
    
            for (let index = 0; index < this.products.length; index++) {
                var product = this.products[index]
                var array_index = index % this.cols;
                if(typeof products[array_index] === 'undefined') {
                    products.push([product]);
                }
                else {
                    products[array_index].push(product)
                }
                
            }

            return products
        }
    },
    methods: {
        getProducts()
        {
            const params = new URLSearchParams(window.location.search);

            let page = this.page = Number(params.get('page') ? params.get('page') : this.page) 


            this.categories = params.getAll('categories[]')
            this.mediums = params.getAll('mediums[]')
            this.search = params.get('search')
            this.artist_id = params.get('artist_id')
            this.subjects = params.getAll('subjects[]')
            this.styles = params.getAll('styles[]')
            this.orientations = params.getAll('orientations[]')
            this.price_range = params.getAll('price_range[]')
            this.colours = params.getAll('colours[]')

            const vm = this
            this.loading = true
            axios.post(this.members_url, {
                page: this.page,
                categories: this.categories,
                search: this.search,
                mediums: this.mediums,
                subjects: this.subjects,
                styles: this.styles,
                orientations: this.orientations,
                price_range: this.price_range,
                artist_id: this.artist_id,
                colours: this.colours
            })
            .then(function (response) {
                vm.loading = false
                vm.products.push(...response.data);
                if(vm.products.length && !response.data.length) {
                    vm.finished_loading_results = true
                    const setParams = new URLSearchParams(location.search);
                    setParams.set('page', vm.lastValidPage);

                    window.history.replaceState({}, '', `${location.pathname}?${setParams.toString()}`);
                }
                else {
                    vm.lastValidPage = vm.page
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        incrementPageNumber(){

            if(!this.finished_loading_results) {

                this.page++

                const setParams = new URLSearchParams(location.search);
                setParams.set('page', this.page);

                setParams.toString();
                window.history.replaceState({}, '', `${location.pathname}?${setParams.toString()}`);
            }
        },
        onScroll (event) {
            if (this.disableScroll) {
                return;
            }
            if (!this.finished_loading_results && event.target.scrollingElement.scrollTop + this.preloadOffset >= event.target.scrollingElement.scrollHeight - event.target.scrollingElement.offsetHeight && this.loading != true) {
                this.incrementPageNumber()
                this.getProducts()
            }
        },

        onResize() {
            this.width = window.innerWidth
            if (this.width >= this.bootstrap_min_width.md) 
            {
                this.cols = 4
            } 
            else {
                this.cols = 2
            }

        }
    },


    mounted() {
        this.getProducts(); 
        this.onResize();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            document.addEventListener("scroll", this.onScroll);
        });
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    }
}
</script>

<style>
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: black;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}

</style>